export default __webpack_public_path__ + "static/media/Domain_Section_GoDaddy.28b4db8a.webp";